import React, { useEffect, useLayoutEffect, useState } from "react";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";
import { useStore } from "react-redux";
import common from "../../resources_catalog/js/common/common";
import dummy_img from "../../resources_catalog/images/dummy_img.png";
import right_arrow_gold from "../../resources_catalog/icons/ico_right_arrow_gold.svg";
import ico_more from "../../resources_catalog/icons/ico_more.svg";
import ico_minus from "../../resources_catalog/icons/ico_minus.svg";
import { getNewsList, getNewsListTest } from '../../const/index.js';
import { Link } from "react-router-dom";
import Const from "../../const/RTCC/Const";

import hotel_img_jp_11 from "../../resources_catalog/images/hotel_japan/hotel_kv_jp_11.jpg";
import CommonUtil from "../../common/commonUtil";
import { useRtoaster } from "../../hooks/useRtoaster";

export const CatalogNewsAllContainer = (props) => {

  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  const store = useStore();
  const [newsList, setNewsList] = useState([]);
  const [linkList, setLinkList] = useState([]);
  const [displayAllFlg, setDisplayAllFlg] = useState(false);

  // rtoasterタグ生成
  useRtoaster();

  //この関数は画面レンダリング前に動きます
  useLayoutEffect(() => {
  })

  //この関数は画面レンダリング後に動きます
  useEffect(() => {
    setLinkList([{ path: "/rtcc/catalog/home", label: "ホーム" }]);
    // お知らせApiリクエスト
    if (CommonUtil.getDomain() == Const.RELEASE_PATH) {
      common.doGet(getNewsList, {}, afterGetNewsList);
    } else {
      common.doGet(getNewsListTest, {}, afterGetNewsList);
    }
  }, []);

  // お知らせ一覧取得後処理
  const afterGetNewsList = (res) => {
    if (res.data) {
      let dataList = [];
      res.data.map((value) => {
        let data = {
          title: value.title,
          news_id: value.news_id,
          thumbnail_url: value.thumbnail_url,
          link_url: value.link_url,
          date: value.date
        };
        dataList.push(data);
      });
      setNewsList(dataList);
    }
  };

  const newsDetail = (news_id) => {
    store.dispatch({ type: "NEWS", payload: { news: news_id } })
    history.push("newsDetail");
  }

  // 表示件数変更
  const handleChangeDispNum = () => {
    setDisplayAllFlg(!displayAllFlg);
  }

  // const newsListBlock = [
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../../resources_catalog/images/hotel_japan/hotel_kv_jp_11.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_12.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_13.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_14.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_15.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_11.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_12.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_13.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_14.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_15.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_14.jpg", link: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: "../src/resources_catalog/images/hotel_japan/hotel_kv_jp_15.jpg", link: "", date: "2022.02.14" }
  // ];

  return (
    <div className="catalogNewsAllWrap">
      <div className="catalogNewsAll">
        <div className="catlogBackBlock catalogNewsAllBlock"></div>
        <div className="catalogContentsBlock catalogNewsAllContent">
          <h1 className="catalogNewsAllTitle">お知らせ一覧</h1>
          <p className="catalogNewsAllDate">NEWS</p>
          <div className="catalogNewsAllListWrap">
            {
              newsList.map((data, index) => (
                <div key={"news" + index} className="catalogNewsAllList">
                  <div className="catalogNewsAllListImgWrap">
                    <img src={data.thumbnail_url} alt="" className="catalogNewsAllListImg" />
                  </div>
                  <div className="catalogNewsAllListText">
                    <p className="catalogNewsAllListDate">{data.date}</p>
                    <p className="catalogNewsAllListCaption">{data.title}</p>
                    {data.link_url ?
                      <a href={data.link_url} className="catalogNewsAllListLink" target="_blank" rel="noopener noreferrer">
                        詳細を見る
                        <img src={right_arrow_gold} alt="" />
                      </a>
                      :
                      <a className="catalogNewsAllListLink" onClick={() => newsDetail(data.news_id)}>
                        詳細を見る
                        <img src={right_arrow_gold} alt="" />
                      </a>
                    }
                  </div>
                </div>
              ))
            }
            {/* {
              newsListBlock.map((data, index) => (
                <div key={"news" + index} className="catalogNewsAllList">
                  <div className="catalogNewsAllListImgWrap">
                    <img src={hotel_img_jp_11} alt="" className="catalogNewsAllListImg" />
                  </div>
                  <div className="catalogNewsAllListText">
                    <p className="catalogNewsAllListDate">{data.date}</p>
                    <p className="catalogNewsAllListCaption">{data.title}</p>
                    <a href={data.link} className="catalogNewsAllListLink">
                      詳細を見る
                      <img src={right_arrow_gold} alt="" />
                    </a>
                  </div>
                </div>
              ))
            } */}
          </div>
          <div className={newsList && newsList.length <= Const.MAX_DISP_NUM ? "hiddenItem" : "catalogNewsAllMore"} onClick={handleChangeDispNum}>
          {displayAllFlg ? <>
            <img src={ico_minus} alt="" className="catalogNewsAllListImgAllMore" />
            <p>表示数を戻す</p>
          </>
            : <>
              <img src={ico_more} alt="" className="catalogNewsAllListImgAllMore" />
              <p>もっと見る</p>
            </>
          }
        </div>
        </div>
        <div className={isWideTablet ? "none" : "catalogBreadCrumb"}>
          {linkList.map((value, index) => (
            <div key={"link" + index} style={{ display: "flex" }}>
              <Link to={value.path} className="link">{value.label}</Link>
              <div className="lastLabel">&gt;</div>
            </div>
          ))}
          <div className="lastLabel">お知らせ一覧</div>
        </div>
      </div>
    </div>
  );
};
